import React from 'react';

const ProductReviewStars = ({ contentData }) => {
  return (
    <div id='reviewHeader'>
      <div
        data-bv-show='rating_summary'
        data-bv-product-id={`${contentData?.partNumber}-${contentData?.skus[0]?.partnumber}`}
      ></div>
    </div>
  );
};

export default ProductReviewStars;
